export default {
  title: 'Productos destacados',
};
